import { FC } from 'react';
import { ItemList } from '@app/form_components';
import {
  ArgumentInput,
  FormControlProps,
  ValueOrVariableType
} from '@app/types';
import {
  ArgumentInputForm,
  ArgumentInputFormProps
} from './ArgumentInputForm';

export type ArgumentInputsFormProps = (
  FormControlProps<ArgumentInput[]>
  & Pick<ArgumentInputFormProps, 'argumentScope'>
  & {
    label: string;
  }
);

export const ArgumentInputsForm: FC<ArgumentInputsFormProps> = ({
  argumentScope,
  label,
  ...listProps
}) => {
  return (
    <ItemList<ArgumentInput>
      {...listProps}
      getKey={(argument) => argument.id}
      label={label}
      renderForm={(props) => (
        <ArgumentInputForm argumentScope={argumentScope} {...props} />
      )}
      renderRow={({ value }) => {
        const valueOrVarName = (value.type === ValueOrVariableType.value) ? (
          value.value
        ) : value.varName;

        return (
          <>
            <h4>To: {value.argumentName}</h4>
            <div className='subtext'>From: {valueOrVarName}</div>
          </>
        );
      }}
    />
  );
};
